"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Name
 * @since 0.1.5
 * @version 0.1.6
 */
exports.name = new RegExp("^[A-Z](([\\w\u00C0-\u017F,.])?([\\s'\\-])?([\\w\u00C0-\u017F.]))*$");
/**
 * Height
 * Min 50 centimeters
 * Max 280 centimeters
 * @since 0.1.92
 * @version 0.1.92
 */
exports.height = new RegExp('^([5-8][0-9]|9[0-9]|1[0-9]{2}|2[0-7][0-9]|280)$');
/**
 * Weight
 * Min 5000 grammes
 * Max 280000 grammes
 * @since 0.1.93
 * @version 0.1.93
 */
exports.weight = new RegExp('^([3-8][0-9]{3}|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9]|[1-8][0-9]{4}|9[0-8][0-9]{3}|99[0-8][0-9]{2}|999[0-8][0-9]|9999[0-9]|[1-4][0-9]{5}|500000)$');
exports.default = {
    name: exports.name,
    height: exports.height,
    weight: exports.weight,
};
//# sourceMappingURL=user.js.map